// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".product-accordion[data-v-197fa96a] b{font-weight:800}.product-accordion[data-v-197fa96a] .ota-p18{font-size:1.5rem}.right-flex[data-v-197fa96a]{max-width:75rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
